import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { LoadingSpinner } from '@/components/ui/LoadingSpinner';

export function AdminRoute() {
    // @ts-ignore - The AuthContext type definition might be missing isLoading but the provider has it or we check !init
    const { user, isLoading } = useAuth() as any;

    if (isLoading) {
        return <LoadingSpinner fullScreen />;
    }

    if (!user || user.role !== 'admin') {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
}
